<template>
    <div>
        测试中n...
        <a href="baidumap://map/marker?location=40.047669,116.313082&title=我的位置&content=百度奎科大厦&src=ios.baidu.openAPIdemo">地图标点</a>
        <!-- 百度文档 -->
        <!-- http://lbsyun.baidu.com/index.php?title=uri/api/ios -->
    </div>
</template>

<script>
export default {
    mounted() {
        // 本示例是通过该URL启动地图app并进入北京市从中关村到五道口的驾车导航路线图'
        window.location.href = 'baidumap://map/direction?origin=中关村&destination=五道口&mode=driving&region=北京&src=ios.baidu.openAPIdemo'
        setTimeout(() => {
            window.location.href = 'baidumap://map/direction?origin=中关村&destination=五道口&mode=driving&region=北京&src=ios.baidu.openAPIdemo'
            // window.location.href = 'appleMap://'
            // window.location.href = 'taobao://'
        }, 600)
    }
}
</script>
